import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { get, isUndefined } from 'lodash'

type State = {
  virtual: '' | 'only' | 'ignore'
}

const INITIAL_STATE: State = {
  virtual: '',
}

const setIfDefined = (state: State, key: 'virtual', newValue: State['virtual']) => {
  if (isUndefined(state[key])) {
    return state
  }
  return {
    ...state,
    [key]: newValue,
  }
}

const slice = createSlice({
  name: 'calendar-visit-type-filter',
  initialState: INITIAL_STATE,
  reducers: {
    '@@INIT': (state) => {
      state.virtual = get(state, 'virtual', INITIAL_STATE.virtual)
    },
    changeFilter: (state, action: PayloadAction<{ name: 'virtual'; value: State['virtual'] }>) => {
      return setIfDefined(state, action.payload.name, action.payload.value)
    },
  },
})
export const actions = slice.actions
export default slice.reducer
